var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),(_vm.$store.isSignedIn)?_c('Navbar'):_c('div',{staticClass:"no-user"}),_c('div',{staticClass:"rout-container"},[_c('router-view')],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }